export const urlify = (text: string) => {
  const urlRegex = /(https?:\/\/\S+)/g;

  return text?.replace(urlRegex, url => '<a target="_blank" href="' + url + '">' + url + '</a>');
};
